"use client";

import * as AvatarPrimitive from "@radix-ui/react-avatar";
import type { ImgHTMLAttributes, Ref } from "react";

import { cn } from "../../utils/cn.util";
import { Image as BaseImage } from "../image";
import { isImageUrl } from "./utils";

export type AvatarImageProps = ImgHTMLAttributes<HTMLImageElement> & {
  ref?: Ref<HTMLImageElement>;
};

/**
 * The avatar's picture: pulses while it loads, and `Avatar.Fallback` follows its `data-loaded` to show itself when it
 * fails. Anything that isn't a URL is left unrendered rather than requested (see `isImageUrl`), so the fallback shows.
 */
export const Image = ({ className, src, ...props }: AvatarImageProps) =>
  typeof src === "string" && isImageUrl(src) ? (
    <BaseImage
      {...props}
      src={src}
      className={cn("peer size-full rounded-full object-cover data-[loaded=error]:invisible", className)}
    />
  ) : null;

Image.displayName = AvatarPrimitive.Image.displayName;
